module.exports = __webpack_public_path__ + "img/asia-admin02.a4d36d1d.png";